import { FC } from 'react'
import type { Product } from '@commerce/types/product'
import { ProductCard, ProductVariantCard } from '@components/product'
import { Container } from '@components/ui'
import { HeadingSeparator } from '@components/yadav/ui'

interface Props {
  relatedProducts: Product[]
}

const RelatedProducts: FC<Props> = ({ relatedProducts }) => {
  return (
    <>
      <Container className="max-w-none w-full" clean>
        <section className="mt-[112px]">
          <h1 className="font-normal text-3.5xl leading-10 text-center font-heading">
            You May Also be Interested In
          </h1>
          <div className="grid grid-cols-2 py-2 px-6 gap-4 mt-12 md:grid-cols-4 md:gap-7">
            {relatedProducts.map((p) => (
              // Don't wrap it with a Link component to avoid a server mismatch.
              // TODO: update related product state to use Link router.
              <a key={p.id} href={`/product/${p.slug}`}>
                {/* <ProductCard
                  noNameTag
                  product={p}
                  cardStyle="default"
                  className="animated fadeIn"
                  imgProps={{
                    width: 260,
                    height: 260,
                  }}
                  type="relatedProducts"
                  noLinkWrapper
                /> */}
                <ProductVariantCard
                  productVariant={p.variants[0]}
                  noNameTag
                  cardStyle="default"
                  className="animated fadeIn"
                  imgProps={{
                    width: 260,
                    height: 260,
                  }}
                  type="relatedProducts"
                  noLinkWrapper
                  inWishlist
                />
              </a>
            ))}
          </div>
        </section>
      </Container>
    </>
  )
}

export default RelatedProducts
